export const PARAMS = [ [ 'n', 'Network' ], [ 'a', 'Affid' ], [ 's', 'Subid' ], [ 'cc', 'Country' ], [ 'c', 'Clicks' ], [ 'nC', 'Net. Clicks' ], [ 'r', 'Revenue' ], [ 'nR', 'Net. Revenue' ], [ 'cD', 'Clicks Diff.' ], [ 'rD', 'Revenue Diff.' ] ];
export const PAGE_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/scenes/BidderQuality/config.js